<template>
  <div class="notice_content">
    <!-- 标题： -->
    <h3>{{contents.title}}</h3>
    <!-- 内容： -->
    <!-- <p>{{contents.content}}</p> -->
    <p v-html="contents.content"></p>
    <div class="time_box">{{contents.createtime}}</div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'NoticeContent',
  props: [
    'contents'
  ],
  data() {
    return {

    }
  },
  components: {

  },
  computed: {

  },
  methods: {

  },
  mounted() {

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.notice_content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 1200px;
  padding: 50px;
  border-radius: 8px;
  border: 1px solid #cccccc;
}
.notice_content >h3 {
  text-align: center;
  font-size: 19px;
  font-weight: bold;
}
.notice_content >p {
  margin: 40px 0;
  width: 100%;
  line-height: 23px;
  text-indent: 26px;
  min-height: 300px;
  padding: 10px;
  /* border: 1px solid #eeeeee; */
  /* background: #eeeeee; */
}
.time_box {
  width: 100%;
  text-align: right;
}
</style>